import { render, staticRenderFns } from "./passReport.vue?vue&type=template&id=5f68d036&scoped=true&"
import script from "./passReport.vue?vue&type=script&lang=js&"
export * from "./passReport.vue?vue&type=script&lang=js&"
import style0 from "./passReport.vue?vue&type=style&index=0&id=5f68d036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68d036",
  null
  
)

export default component.exports